import React from 'react';

import { Grid } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

import { fields, columns } from 'constants/show';
import { InfoRow } from 'containers/Texts';
import { handleObjectString } from 'utils/parsers';

interface ShowInfoProps {
  data: any
  fallbackContent?: keyof typeof fields
}

export default function ShowInfo({ data = {}, fallbackContent }: ShowInfoProps) {
  const { content = fallbackContent } = useParams<GeneralRoute>();
  const templateColumns = columns[content] || 4;

  if (!fields[content]) {
    return null;
  }
  return (
    <Grid
      my={10}
      border="1px"
      borderColor="gray.200"
      borderRadius={8}
      px={12}
      py={10}
      templateColumns={`repeat(${templateColumns}, 1fr)`}>
      {fields[content]?.map((item) => (
        <InfoRow
          key={`field-${item.label}-${item.key}`}
          label={item.label}
          value={handleObjectString(data, item.key) ?? 'N/A'}
          {...item.props}
        />
      ))}
    </Grid>
  );
}
